import PropTypes from "prop-types";
import React from "react";

import FormCheckbox from "../../components/form/FormCheckbox";
import FormDropdown from "../../components/form/FormDropdown";
import ModalDescription from "../../components/modal/ModalDescription";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalRow from "../../components/modal/ModalRow";
import imageFileFormats from "../../constants/imageFileFormats";

const formatOptions = [
  { label: "PDF", value: imageFileFormats.PDF },
  { label: "PNG", value: imageFileFormats.PNG },
  { label: "JPEG", value: imageFileFormats.JPEG },
  { label: "TIFF", value: imageFileFormats.TIFF },
  { label: "GIF", value: imageFileFormats.GIF }
];

const ExportImagePreviewOptions = props => {
  const { isSelectedItemsOnly, onChangeSelectedItemsOnly, hasSelectedItem } = props;

  return (
    <div className="printPreviewOptions">
      <ModalGroup label="Export Image">
        <ModalRow>
          <ModalField label="Format">
            <FormDropdown
              options={formatOptions}
              allowSearch={false}
              value={props.format}
              onChange={props.onChangeFormat}
            />
          </ModalField>
        </ModalRow>
        <ModalRow>
          <ModalField>
            <FormCheckbox
              label="Selected items only"
              checkboxState={isSelectedItemsOnly}
              onChange={onChangeSelectedItemsOnly}
              disabled={!hasSelectedItem}
            />
          </ModalField>
        </ModalRow>
      </ModalGroup>
      {props.pageInfo ? (
        <ModalGroup label="Dimensions">
          <ModalRow>
            <ModalField>
              <ModalDescription>
                <span>
                  {Math.ceil(props.pageInfo.paperWidth)} x {Math.ceil(props.pageInfo.paperHeight)}
                  {props.format === imageFileFormats.PDF ? " points" : " pixels"}
                </span>
              </ModalDescription>
            </ModalField>
          </ModalRow>
        </ModalGroup>
      ) : null}
    </div>
  );
};

ExportImagePreviewOptions.propTypes = {
  hasSelectedItem: PropTypes.bool,
  isSelectedItemsOnly: PropTypes.bool.isRequired,
  onChangeSelectedItemsOnly: PropTypes.func.isRequired,
  format: PropTypes.string.isRequired,
  onChangeFormat: PropTypes.func.isRequired,
  pageInfo: PropTypes.object
};

export default ExportImagePreviewOptions;
